import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import AddClient from "./AddClient";
import SideNavBar from "../sidebar/SideNav";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import { useInView } from 'react-intersection-observer';

const Clients = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openClient, setOpenClient] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [clientData, setClientData] = useState({
    name: "",
    email: "",
    phone: "",
    gender: "",
    address: "",
    company: "",
  });
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingClients, setIsFetchingClients] = useState(false)
  const { ref, inView } = useInView({
        threshold: 0,
    });
  const [limit, setLimit] = useState(10)
  const [genders, setGenders] = useState([])

  useEffect(() => {
          if (inView) {
            if(limit < totalPages * 10){
              setLimit(prev=>prev+10)
            }
          }
        }, [inView]);

  const fetchGender = async () => {
      try {
        const response = await getRequest("filter/gender");
        const genderArray = Object.keys(response).map((key) => ({
          label: key,
          value: response[key],
        }));
        setGenders(genderArray);
      } catch (error) {
        console.error("Error fetching Filter:", error);
      }
    };
  
    useEffect(()=>{
      fetchGender()
    }, [])

  const fetchClients = async () => {
    const access = localStorage.getItem("access");
    try {
      !isSmallScreen && setLoading(true)
      setIsFetchingClients(true)
      const response = await getRequest("client", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: !isSmallScreen ? {page:page} : {limit: limit}
      });
      setIsFetchingClients(false)
      setTotalPages(response?.totals?.total_pages)
      setClients(response?.data)
      } catch (error) {
      console.error("Error fetching Clients:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [page, limit]);

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`client/${deleteId}`, access);
      fetchClients();
      handleClose();

      showSnackbar(response, "success");
    } catch (error) {

      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleClient = (id) => {
    setOpenClient(true);
    setClientId(id);
  };

  useEffect(() => {
    if (clientId !== null) {
      const fetchClients = async () => {
        const access = localStorage.getItem("access");
        try {
          const response = await getRequest(`client/${clientId}`, {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          });
          let returnGender = () => {
              return genders.find(
                        (gender) => gender.value === response.gender
                    )?.label
          }
          setClientData((prevData) => ({
            ...prevData,
            name: response.name || "N/A",
            email: response.email || "N/A",
            phone: response.phone || "N/A",
            gender: returnGender(),
            address: response.address || "N/A",
            company: response.company || "N/A",
          }));
        } catch (error) {
          console.error("Error fetching Client:", error);
        }
      };
      fetchClients();
    }
  }, [clientId]);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const selectClient = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    setOpenClient(false);
    setClientId(null);
    fetchClients();
    setDeleteId(null);
    setUpdateId(null);
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  }

  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        <SideNavBar />
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3.2rem' : '0.5rem' } 0.5rem 0.5rem 0.5rem`, width: '100%' }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              <Grid item>
                <h1>Clients</h1>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOpen}
                  sx={{
                    backgroundColor: "#fff",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#e1e1e1",
                    },
                  }}
                >
                  Add Client
                </Button>
              </Grid>
            </Grid>
            {clients.length === 0 ? (
              <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table style={{
                      borderRadius: "25px",
                      borderCollapse: "separate",
                      overflow: "hidden",
                    }}>
                      <TableHead>
                        <TableRow>
                          <TableCell style={headingTableCellStyle}>
                            ID
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Client Name
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Email
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Phone
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Company
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {clients.map((client, id) => (
                          <TableRow key={id}
                          style={{
                            cursor: "pointer",
                            height: '60px'
                          }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleClient(client._id)}
                          >
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {client.name}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {client.email}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {client.phone}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {client.company}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClient(client._id)}}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectClient(client._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "5px",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(client._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1} justifyContent='center'>
                    {clients.map((client, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref = {id+1 === clients.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleClient(client._id)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <CardContent sx={{padding: '16px 2px 16px 4px'}}>
                              <Typography variant="h5">
                                {client.name}
                              </Typography>
                              <Typography variant="body2">
                                {client.company}
                                <br />
                                {client.email}
                              </Typography>
                            </CardContent>
                            <CardActions sx={{paddingRight: '0px'}}>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "1px",
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClient(client._id)}}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "1px",
                                }}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectClient(client._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "10px",
                                }}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(client._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Box>

          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you Sure You Want to Delete this Client?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openClient}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "90%", md: "45%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              Client Details
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem", }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Client Name:</b> {clientData.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Email:</b> {clientData.email}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Phone:</b> {clientData.phone}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Gender:</b> {clientData.gender}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Company Name:</b> {clientData.company}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Address:</b> {clientData.address}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <AddClient
            open={openModal}
            handleClose={handleClose}
            clientId={updateId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingClients ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
                    <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
                  </Grid>}
    </>
  );
};

export default Clients;
